import useSWR from 'swr'
import { GetSessionID } from '../Utility/SessionUtility';

/**
 * 国マスタの型
 */
export interface UserMasterType {
    user_id: number,
    login_id: string,
    user_name: string,
    authority_id: number,
    confirm_status: boolean
}

/**
 * サーバから返ってくるデータの初期状態の型
 * 余分なデータを削除するために使用
 */
interface UserMasterTempType {
    id: number,
    login_id: string,
    login_name: string,
    password: string | null,
    comment: string | null,
    authority_id: number,
    authority_fame: string,
    authority_name: string,
    select_num: number | null,
    confirm_status: number,
    target_year: string | null
}

export function useUserMaster() {

    const fetchAddress = `/competition/api/management/tmc010/find?sessionId=${GetSessionID()}`;

    const fetcher = () => fetch(fetchAddress)
    .then(res => {
        return res.json();
    })
    .then(data => {
        let userData: Array<UserMasterType> = []
        data.user_data.forEach((item:UserMasterTempType) => {
            userData.push({
                user_id: item.id,
                login_id: item.login_id,
                user_name: item.login_name,
                authority_id: item.authority_id,
                confirm_status: item.confirm_status === 2 ? true : false
            })
        })

        return(userData);
    });

    const {data, error, isLoading, mutate} = useSWR(`UserMaster`, fetcher, {revalidateOnFocus:false, revalidateOnReconnect:false});

    return{
        /**
         * ユーザーマスタ配列
         */
        userMaster: data,
        
        /**
         * ロード中フラグ
         */
        isLoading,

        /**
         * エラーフラグ
         */
        isError: error,

        /**
         * 再取得関数
         */
        mutate,
    }
}